/******************************************************************

Sscroll spy script

Description:  This looks for the scrolling distance and either shows of hides a submenu.

@copyright Zooma 2018

/******************************************************************/

function hideNav() {
  if (scrollY >= distance) {
    $('body').addClass('top-nav-hidden');
  } else {
    $('body').removeClass('top-nav-hidden');    
  }

  if (scrollY >= elementOffset) {
    $('body').addClass('content-nav-fixed');    
  } else {
    $('body').removeClass('content-nav-fixed');    
  }
}

// test which page we are on
const url = window.location.href;

// Add scroll listener for collections and product pages
if (url.includes('collections') || url.includes('products')) {

  window.addEventListener("scroll",function() {

    // test which coordinate we are 
    const $body = $('body')
    const scrollY = window.scrollY;
    let elementOffset = 0;
    
    // set distance for collection menu
    if (url.includes('collections')) {
      elementOffset = $('#CollectionSection .ContentNav-outer').offset().top      
    } else if (url.includes('products')) {    
      elementOffset = $('#product-submenu').offset().top      
    } 
       
    const distance = elementOffset - $('.TopNav').height();

    // Check if Top nav should be hidden
    if (scrollY >= distance) {
      $body.addClass('top-nav-hidden');
    } else {
      $body.removeClass('top-nav-hidden');    
    }
  
    // Check if Content nav should be hidden
    if (scrollY >= elementOffset) {
      $body.addClass('content-nav-fixed');    
    } else {
      $body.removeClass('content-nav-fixed');    
    }

    //console.log({scrollY}, {distance}, {elementOffset})
    
  }, false);
}

/* ========================================================================
 Menu Scrolling active class script

 Description:   This sets an active class or no class depending on a click.

 @copyright Zooma 2018

 * ======================================================================== */

 function click(event) {
    var current = document.getElementsByClassName("active");
    if (current.length > 0) { 
      current[0].className = current[0].className.replace(" active", "");
    }
    this.className += " active";
  }
